import React from 'react';
import useGoToPage from 'hooks/useGoToPage';
import pages from 'routes/pages';
import { useShouldUpdateNote } from '../../hooks/useShouldUpdateNote';
import { DashboardContent } from 'components/organisms/Contents/DashboardContent';
import { useDispatch } from 'react-redux';
import { saveLastSeenTab } from 'store/actions/ui.actions';

const Dashboard = () => {
  useShouldUpdateNote();
  const dispatch = useDispatch();
  const goToEspaceProf = useGoToPage(pages.ESPACE_PROF.path);
  const goToControlTab = () => {
    dispatch(saveLastSeenTab(5));
    goToEspaceProf();
  };

  return (
    <>
      <DashboardContent
        goToEspaceProf={goToEspaceProf}
        goToControlTab={goToControlTab}
      />
    </>
  );
};

export default Dashboard;
